// import React from "react";
import Gallery from "../../default-components/Gallery";
const PGGallery = () => {
  return (
    <div>
      <Gallery
        category="gallery"
        pageName="gallery"
        section="gallery"
        // addMoreImagesButton={false}
        addMoreVideosButton={false}
        addMoreTextContentButton={false}
      />
      <br />
      <br />
    </div>
  );
};

export default PGGallery;
